export enum OrganizationTypes {
  PRIMARY = 'primary',
  SUB_AGENCY = 'sub-agency',
  THIRD_PARTY = 'third-party',
  DEMO = 'demo',
}
